module.exports = __webpack_public_path__ + "static/media/info16_datos_actualizados_JDE.39bbb7fd.png";